import { Helmet } from 'react-helmet';
import { EquipmentsMaintenanceTable } from '../../components/Tables/Sigma/EquipmentsMaintenanceTable';

const EquipmentsMaintenance = () => {
  return (
    <div className='table-module-container'>
      <Helmet>
        <title>Mantenimientos a tipos de equipos</title>
      </Helmet>
      <div className='datatable'>
        <EquipmentsMaintenanceTable />
      </div>
    </div>
  );
};

export default EquipmentsMaintenance;
